export default __webpack_public_path__ + "static/media/15_2B6KT35_retouche-min.22ce9a36.jpg";